import { React, useEffect, useState } from 'react'
import { Grid, GridItem, Flex, useToast } from '@chakra-ui/react'
import { Heading, BackButton } from '../../../components/UI'
import FormUploadMasivePrograms from '../../../components/FormUploadMasivePrograms'
import TableProgramsSync from '../../../components/TableProgramsSync'
import FiltersProgramsSync from '../../../components/FiltersProgramsSync'
import { useProgramsSync } from '../../../hooks/ProgramsSync'

const ProgramsUpload = () => {
  const toast = useToast()

  /* table */
  const initialFiltersProgramsSync = {
    program: 'Todos los programas'
  }
  const [filtersProgramsSync, setFiltersProgramsSync] = useState(
    initialFiltersProgramsSync
  )

  const [page, setPage] = useState(0)
  const limit = 6
  const {
    data: programsSync,
    isLoading,
    isFetching,
    isError,
    refetch
  } = useProgramsSync(filtersProgramsSync, page, limit)

  useEffect(() => {
    setPage(0)
  }, [filtersProgramsSync])
  /* table */

  useEffect(() => {
    toast.closeAll()
  }, [])

  return (
    <>
      <Flex direction={'column'} px={10}>
        <Flex
          minW={'100%'}
          align={{
            lg: 'center',
            md: 'start',
            sm: 'start'
          }}
          direction={{
            lg: 'row',
            md: 'column',
            sm: 'column'
          }}
        >
          <BackButton showText={false} />
          <Heading title={'CARGA HISTÓRICA DE PROGRAMAS'} />
        </Flex>

        <Grid templateColumns={'repeat(1, 1fr)'} py={10}>
          <GridItem borderBottom={'1px solid #2E7423'} pb={4}>
            <FiltersProgramsSync
              filtersProgramsSync={filtersProgramsSync}
              setFiltersProgramsSync={setFiltersProgramsSync}
              initialFiltersProgramsSync={initialFiltersProgramsSync}
            />
            <br />
            <FormUploadMasivePrograms refetch={refetch} />
          </GridItem>
          <GridItem>
            <TableProgramsSync
              page={page}
              setPage={setPage}
              limit={limit}
              programsSync={programsSync}
              isLoading={isLoading}
              isFetching={isFetching}
              isError={isError}
            />
          </GridItem>
        </Grid>
      </Flex>
    </>
  )
}

export default ProgramsUpload
